import React from 'react';
import { useTranslation } from 'react-i18next';
import HeroImage from '../../../../assets/images/services/crypto/nauru/hero-image.jpg'
import BreadCrumbs from "../../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../../components/Constant/HeroRightImage/HeroRightImage";
import PageList from "../../../../components/Constant/List/List";
import { GoDotFill } from "react-icons/go";
import CTA from "../../../../components/Constant/cta/CTA";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Button from "../../../../components/Constant/button/Button";
import SEO from "../../../../utils/SEO";

function CryptoLicenseNauru () {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.crypto-license-nauru.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });
    const withIcon = (k) => (obj(k) || []).map((it) => ({ ...it, icon: GoDotFill }));
    const dots = (k) => (obj(k) || []).map((paragraph) => ({ paragraph, icon: GoDotFill }));

    const BreadCrumbsData = [
        { name: tp('breadcrumb.home', 'Offshore Advisory'), link: '/' },
        { name: tp('breadcrumb.self', 'Crypto License – Nauru'), link: '/crypto-license-nauru' },
    ];

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                url="/crypto-license-nauru"
            />

            <section className='banking-license-section section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='banking-license-container container'>
                    <br/>
                    <h1 className='section-title'>{tp('h1')}</h1>

                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>{tp('subtitle')}</h3>
                            <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('intro') }} />
                            <h3 className='page-subtitle'>{tp('consultTitle')}</h3>
                            <p className='page-paragraph'>{tp('consultText')}</p>
                            <Button
                                text={tp('consultButton')}
                                link="/contact"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImage} />
                    </div>

                    <div className='flex-start'>
                        <br/>
                        <h3 className='page-title'>{tp('overview.title')}</h3>
                        <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('overview.lead') }} />
                        <PageList items={dots('overview.activities')} />
                        <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('overview.after') }} />

                        <h3 className='page-title'>{tp('whyConsider.title')}</h3>
                        <PageList items={withIcon('whyConsider.items')} />

                        <h3 className='page-title'>{tp('whoQualifies.title')}</h3>
                        <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('whoQualifies.lead') }} />
                        <PageList items={withIcon('whoQualifies.items')} />
                        <p className='page-paragraph'>{tp('whoQualifies.after')}</p>

                        <h3 className='page-title'>{tp('requirements.title')}</h3>
                        <p className='page-paragraph'>{tp('requirements.lead')}</p>
                        <PageList items={withIcon('requirements.items')} />

                        <h3 className='page-title'>{tp('ongoing.title')}</h3>
                        <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('ongoing.lead') }} />
                        <PageList items={dots('ongoing.items')} />
                        <p className='page-paragraph'>{tp('ongoing.after')}</p>

                        <h3 className='page-title'>{tp('oversight.title')}</h3>
                        <p className='page-paragraph'>{tp('oversight.lead')}</p>
                        <PageList items={withIcon('oversight.items')} />
                        <p className='page-paragraph'>{tp('oversight.after')}</p>

                        <h3 className='page-title'>{tp('banking.title')}</h3>
                        <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('banking.lead') }} />
                        <PageList items={dots('banking.items')} />
                        <p className='page-paragraph'>{tp('banking.after')}</p>

                        <h3 className='page-title'>{tp('process.title')}</h3>
                        <PageList items={withIcon('process.items')} />

                        <h3 className='page-title'>{tp('timeline.title')}</h3>
                        <p className='page-paragraph'>{tp('timeline.lead')}</p>
                        <PageList items={withIcon('timeline.items')} />
                        <p className='page-paragraph'>{tp('timeline.after')}</p>

                        <h3 className='page-title'>{tp('cost.title')}</h3>
                        <p className='page-paragraph'>{tp('cost.lead')}</p>
                        <PageList items={dots('cost.items')} />
                        <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('cost.after') }} />

                        <h3 className='page-title'>{tp('who.title')}</h3>
                        <p className='page-paragraph'>{tp('who.lead')}</p>
                        <PageList items={dots('who.items')} />

                        <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                        <h3 className='page-title'>{tp('notice.title')}</h3>
                        <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('notice.lead') }} />
                        <PageList items={dots('notice.items')} />
                        <p className='page-paragraph'>{tp('notice.after')}</p>
                    </div>

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/contact"
                    />
                </div>
            </section>
        </main>
    );
}

export default CryptoLicenseNauru;
